module.exports = __webpack_public_path__ + "static/media/model-patrol-04-lwb.4b3f0290.webp";